import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import { storage } from "./services/storage";
import { refreshToken, getTokenExpiryMs } from "./services/api";

// ✅ IMPORTAR COMPONENTES
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard"; 

const App = () => {
  const [auth, setAuth] = useState(Boolean(storage.get("token")));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Verificar si hay token guardado
    const token = storage.get("token");
    setAuth(Boolean(token));
    setLoading(false);
  }, []);

  useEffect(() => {
    let refreshTimer = null;
    let isMounted = true;

    const scheduleRefresh = (token) => {
      if (!token) return;
      const expiryMs = getTokenExpiryMs(token);
      if (!expiryMs) return;
      const now = Date.now();
      const refreshIn = Math.max(expiryMs - now - 60 * 1000, 10 * 1000);
      refreshTimer = window.setTimeout(async () => {
        const result = await refreshToken();
        if (result?.success) {
          const nextToken = storage.get("token");
          if (isMounted) scheduleRefresh(nextToken);
        }
      }, refreshIn);
    };

    const token = storage.get("token");
    scheduleRefresh(token);

    return () => {
      isMounted = false;
      if (refreshTimer) {
        clearTimeout(refreshTimer);
      }
    };
  }, []);

  // ✅ LISTENER PARA CAMBIOS EN LOCALSTORAGE
  useEffect(() => {
    const handleStorageChange = () => {
      const token = storage.get("token");
      const hasToken = Boolean(token);
      setAuth(hasToken);
      console.log("📊 Storage cambió, auth ahora es:", hasToken);
    };

    // ✅ ESCUCHAR CAMBIOS EN LOCALSTORAGE
    window.addEventListener("storage", handleStorageChange);
    
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  if (loading) {
    return (
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        fontSize: "1.2rem",
        color: "#666"
      }}>
        ⏳ Cargando...
      </div>
    );
  }

  return (
    // ✅ ENVOLVER CON ROUTER
    <Router>
      <Routes>
        {/* ✅ RUTA LOGIN (sin autenticación) */}
        <Route
          path="/login"
          element={
            auth ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Login setAuth={setAuth} />
            )
          }
        />

        {/* ✅ RUTA DASHBOARD (con autenticación) */}
        <Route
          path="/dashboard"
          element={
            auth ? (
              <> 
                <Dashboard />
              </>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        {/* ✅ RUTA RAÍZ - Redirigir según autenticación */}
        <Route
          path="/"
          element={
            <Navigate to={auth ? "/dashboard" : "/login"} replace />
          }
        />

        {/* ✅ RUTA 404 */}
        <Route
          path="*"
          element={
            <Navigate to={auth ? "/dashboard" : "/login"} replace />
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
